import React from 'react'
import type { HubProject } from '../../../api/data360'
import {
  ProjectHubListColgroup,
  PROJECT_HUB_LIST_TH_CLASS
} from './projectHubShared'
import ProjectHubListRow from './ProjectHubListItem'
import ProjectHubListRowMobile from './ProjectHubListRowMobile'

interface ProjectHubListViewProps {
  projects: HubProject[]
  onOpen: (project: HubProject) => void
}

export function ProjectHubListHeader() {
  return (
    <thead className="bg-[#FAFBFC]">
      <tr className="border-b border-[#EEF0F3]">
        <th className={PROJECT_HUB_LIST_TH_CLASS}>Project</th>
        <th className={PROJECT_HUB_LIST_TH_CLASS}>Client</th>
        <th className={PROJECT_HUB_LIST_TH_CLASS}>Categories</th>
        <th className={PROJECT_HUB_LIST_TH_CLASS}>Pipe sets</th>
        {/* <th className={`${PROJECT_HUB_LIST_TH_CLASS}`}>Actions</th> */}
      </tr>
    </thead>
  )
}

export default function ProjectHubListView({ projects, onOpen }: ProjectHubListViewProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-[#E2E5EA] bg-white">
      <table className="hidden w-full table-fixed border-collapse lg:table">
        <ProjectHubListColgroup />
        <ProjectHubListHeader />
        <tbody className="divide-y divide-[#EEF0F3]">
          {projects.map((project) => (
            <ProjectHubListRow
              key={project.wpsShadowId || project.id || `d360-${project.data360ProjectId}`}
              project={project}
              onOpen={onOpen}
            />
          ))}
        </tbody>
      </table>

      <div className="divide-y divide-[#EEF0F3] lg:hidden">
        {projects.map((project) => (
          <ProjectHubListRowMobile
            key={project.wpsShadowId || project.id || `d360-${project.data360ProjectId}`}
            project={project}
            onOpen={onOpen}
          />
        ))}
      </div>
    </div>
  )
}
